export const isNumberValidator = (value: any) => {
  const exp = /^[0-9]*$/;
  return exp.test(value);
};

export const isPhoneNumberValidator = (value: any) => {
  const exp = /^[0-9]{0,11}$/;
  return exp.test(value);
};

export const isCertNumberValidator = (value: any) => {
  const exp = /^[0-9]{0,4}$/;
  return exp.test(value);
};
